import React, { useRef, useMemo, useState, useEffect } from 'react';
import { Line } from '@react-three/drei';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';

const WaterLine = ({ 
    // yLevel = 0, // Removed
    width = 20, 
    color = '#5cadded', 
    lineWidth = 2, 
    segments = 40, 
    waveHeight = 0.08, 
    waveSpeed = 1.5, 
    waveFrequency = 0.3, 
    modelPosition = [0, 0, 0]
}) => {
  const lineRef = useRef();

  // Define base offset for the waterline relative to model Y
  const baseOffsetY = 0.2;

  // Store the initial points definition (only X changes)
  const initialPoints = useMemo(() => {
    const points = [];
    for (let i = 0; i <= segments; i++) {
      const x = (i / segments - 0.5) * width;
      points.push(new THREE.Vector3(x, 0, 0)); // Initialize Y and Z to 0
    }
    return points;
  }, [segments, width]);

  // State to hold the points that will be updated each frame
  const [dynamicPoints, setDynamicPoints] = useState(initialPoints);

  // Update point Y positions in useFrame
  useFrame((state) => {
    if (lineRef.current) {
      const time = state.clock.elapsedTime;
      const [modelX, modelY, modelZ] = modelPosition; 

      // Create a new array to avoid mutating state directly
      const newPoints = initialPoints.map((p, index) => {
        const x = p.x; // Use the initial X position
        
        // Calculate wave offset based on X position and time
        // Combine two waves for more natural look
        const wave1 = Math.sin(x * waveFrequency + time * waveSpeed) * waveHeight * 0.6;
        const wave2 = Math.sin(x * waveFrequency * 0.5 + time * waveSpeed * 0.8) * waveHeight * 0.4;
        const waveOffsetY = wave1 + wave2;
        
        // Return a new vector with updated Y
        return new THREE.Vector3(x, waveOffsetY, 0); // Y is relative to the line's origin now
      });

      // Update the state that's passed to the Line component
      setDynamicPoints(newPoints);

      // Set the *overall* position of the Line object
      // The wave calculation is relative to this position
      lineRef.current.position.set(modelX, modelY + baseOffsetY, modelZ); 
    }
  });

  return (
    <Line
      ref={lineRef}
      points={dynamicPoints} // <<< Use the dynamic points state
      color={color}
      lineWidth={lineWidth}
      // Position is set in useFrame
    />
  );
};

export default WaterLine; 